import React, { useState, useEffect } from "react";
import TopBar from "../../components/layout/TopBar";
import FooterBar from "../../components/layout/FooterBar";
import ProductGuide from "../dashboard/ProductGuide";
import "./LandingPageNew.css";
import "./LandingGuidePage.css";

const LandingGuidePage = () => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("theme");
    return saved || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <div className="landing-page-new">
      <TopBar theme={theme} toggleTheme={toggleTheme} />
      <main className="landing-guide-main">
        <ProductGuide />
      </main>
      <FooterBar theme={theme} />
    </div>
  );
};

export default LandingGuidePage;
